import Location from './components/Location'

const WayTo = () => {
  return <Location />
}

export default WayTo
